module.exports = __webpack_public_path__ + "img/dress10.b6978c3f.jpeg";